import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@fontsource-variable/public-sans";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { UIProvider } from "./app/context";
import { router } from "./app/router";
import { reportUncaught } from "./lib/report";
import "./styles/app.css";

reportUncaught();

const client = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: (count, error) => count < 1 && (error as { status?: number }).status !== 401 } },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <UIProvider>
        <RouterProvider router={router} />
      </UIProvider>
    </QueryClientProvider>
  </StrictMode>,
);
